<template>
  <GenericModuleForm
    :title="behaviourModuleName"
    :model-value="state.isActive"
    :loading="isLoading"
    :response-message="state.response.message"
    :response-type="state.response.type"
    :description="behaviourModuleDescription"
    help-center-key="behaviour_management_module"
    @toggle="toggleBehaviourModule"
    @dismiss-response="resetResponse"
  />
</template>

<script>
import behaviourConstants from "@/constants/behaviourManagementConstants.js"
import GenericModuleForm from "@/v3components/Forms/ModuleListForms/GenericModuleForm.vue"
import { computed, onMounted, reactive, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "BehaviourManagementModuleForm",
  components: {
    GenericModuleForm
  },
  setup() {
    const store = useStore()
    const isLoading = ref(false)

    const state = reactive({
      response: {
        type: "",
        message: "",
        errors: {}
      },
      isActive: true
    })

    const isBehaviourModuleActive = computed(() => {
      return store.getters["behaviourSettings/isBehaviourModuleActive"]
    })

    const resetResponse = () => {
      state.response = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.response = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.response = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }

    const toggleBehaviourModule = async (status) => {
      if (isLoading.value) return

      isLoading.value = true
      try {
        resetResponse()
        await store.dispatch("modules/toggleModule", {
          id: behaviourConstants.BEHAVIOUR_MODULE_ID,
          moduleStatus: {
            status: status ? 1 : 0,
            option_json: []
          }
        })
        state.isActive = status
        await store.dispatch("schools/getActiveModules", {
          clearCacheEntry: true
        })
        setSuccessResponse("Module updated.")
      } catch (error) {
        const response = error.response ? error.response.data : {}
        setErrorResponse(response.message, response.errors)
      } finally {
        isLoading.value = false
      }
    }

    const behaviourTerminology = computed(
      () => store.getters["behaviourSettings/behaviourTerminology"]
    )

    const behaviourModuleName = computed(
      () => behaviourTerminology.value.behaviourManagement
    )

    const behaviourModuleDescription = computed(
      () => behaviourTerminology.value.moduleDescription
    )

    onMounted(() => {
      state.isActive = isBehaviourModuleActive.value
      store.dispatch("behaviourSettings/fetchBehaviourTerminology")
    })

    return {
      isLoading,
      behaviourModuleName,
      behaviourModuleDescription,
      state,
      toggleBehaviourModule,
      resetResponse
    }
  }
}
</script>
